export enum PriceEstimatorDialogPlanType {
  Good = 'GOOD',
  Better = 'BETTER',
  Lite = 'LITE',
  Growth = 'GROWTH',
  Bronze = 'BRONZE',
  Silver = 'SILVER',
  Gold = 'GOLD',
}

const allPriceEstimatorDialogPlanTypes = Object.values(PriceEstimatorDialogPlanType);

export function stringToPriceEstimatorDialogPlanType(stringType: string): PriceEstimatorDialogPlanType | 'UNKNOWN' {
  // eslint-disable-next-line no-restricted-syntax
  for (const enumType of allPriceEstimatorDialogPlanTypes) {
    if (stringType === enumType) {
      return enumType;
    }
  }

  return 'UNKNOWN';
}

export interface PriceEstimatorDialogI18nKeys {
  heading: string;
  ok: string;
  listSize: string;
  plans: Record<PriceEstimatorDialogPlanType, string>;
  unknownPlanType: string;
  overageMessage: string;
}

export type PriceEstimatorTableI18nKeys = Pick<PriceEstimatorDialogI18nKeys, 'listSize' | 'plans' | 'unknownPlanType'>;
